import { Injectable } from '@angular/core';
import { CerraduraModel } from '../models/cerradura.model';
import { PositionService } from '../../positions/position.service';
import { MapPlace } from 'projects/movisat-maps/src/lib/models/map.place';

export type CerraduraList = CerraduraModel & {
  provinciaIdentificacion: string,
  municipioIdentificacion: string,
  poblacionIdentificacion: string,
  calleIdentificacion: string,
  numeroIdentificacion: string,
};

@Injectable({
  providedIn: 'root'
})
export class CerradurasTransformerService {
  public constructor(private positionService: PositionService) { }

  private async getPosition(lat, lng): Promise<MapPlace> {
    return await this.positionService.getDireccion(lat, lng);
  }

  public async transformCerraduraApiToList(cerradura: CerraduraModel): Promise<CerraduraList> {
    const cerraduraTransformed: CerraduraList = {
      ...cerradura,
      provinciaIdentificacion: '',
      municipioIdentificacion: '',
      poblacionIdentificacion: '',
      calleIdentificacion: '',
      numeroIdentificacion: ''
    }

    if(cerradura.lat !== 0 || cerradura.lng !== 0) {
      await this.getPosition(cerradura.lat, cerradura.lng).then(
        (result) => {
            cerraduraTransformed.provinciaIdentificacion = result.AdministrativeArea2;
            cerraduraTransformed.municipioIdentificacion = result.Locality;
            cerraduraTransformed.poblacionIdentificacion = result.District;
            cerraduraTransformed.calleIdentificacion = result.Street;
            cerraduraTransformed.numeroIdentificacion = result.StreetNumber;
        }
      );
    }

    return cerraduraTransformed;
  }
}
